import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=8452%3A20188
 *
 * @param {SvgIconProps} props - svg props
 */
export const BookIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M19 0.5L14 5.5V15L19 10.5V0.5Z' fill={color}/>
            <path d='M22.47 5.2C22 4.96 21.51 4.76 21 4.59V16.62C19.86 16.21 18.69 16 17.5 16C15.6 16 13.72 16.54 12 17.58V5.48C10.38 4.55 8.51 4 6.5 4C4.71 4 3.02 4.44 1.53 5.2C1.2 5.36 1 5.71 1 6.08V18.16C1 18.74 1.47 19.15 2 19.15C2.16 19.15 2.32 19.11 2.48 19.03C3.69 18.4 5.05 18 6.5 18C8.57 18 10.48 18.82 12 20C13.52 18.82 15.43 18 17.5 18C18.95 18 20.31 18.4 21.52 19.04C21.68 19.12 21.84 19.16 22 19.16C22.52 19.16 23 18.75 23 18.17V6.08C23 5.71 22.8 5.36 22.47 5.2ZM10 16.62C8.86 16.21 7.69 16 6.5 16C5.31 16 4.14 16.21 3 16.62V6.71C4.11 6.24 5.28 6 6.5 6C7.7 6 8.89 6.25 10 6.72V16.62Z' fill={color}/>
        </SvgIcon>
    )
}

export default BookIcon
